import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { URL_REDIRECT } from "../../constant/url";
import { slugify } from "../../utils/utils";

export default function SubCategoryRedirect() {
  const { subcategory } = useParams();
  const [categorieState, setCategorieState] = useState(null);
  const [subcategorieState, setSubCategorieState] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    loadCategory(subcategory);
  }, [subcategory]);

  const loadCategory = (subCategoryId) => {
    ExposedAPI.getDistantOrStoredCategories()
      .then((categories) => {
        let subCategory;
        loop: for (let c of categories) {
          for (let sc of c.subCategories) {
            if (sc.id + "" === subCategoryId + "") {
              subCategory = sc;
              setCategorieState(c);
              break loop;
            }
          }
        }
        if (!subCategory) {
          setNotFound(true);
          return;
        }
        setSubCategorieState(subCategory);
      })
      .catch((err) => {
        setNotFound(true);
        console.log(err);
      });
  };

  if (notFound) return <div>Sous catégorie introuvable</div>;
  if (subcategorieState)
    return (
      <Navigate
        to={`${URL_REDIRECT.categorie}${slugify(
          categorieState.label
        )}/${slugify(subcategorieState.label)}`}
        replace
      />
    );

  return <div>Redirection...</div>;
}
